export default __webpack_public_path__ + "static/media/8. Направление по гистологии.673f4446.pdf";